import { render } from "./ConfirmPassword.vue?vue&type=template&id=0327a8e8&scoped=true"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"

import "./ConfirmPassword.vue?vue&type=style&index=0&id=0327a8e8&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0327a8e8"]])

export default __exports__